import { useState, useEffect } from "react";
import {
  Button,
  Grid2,
  Avatar,
  Snackbar,
  Alert,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  IconButton,
  Tooltip,
} from "@mui/material";
import { PreferencesAPI } from "../apis/preferencesAPI";
import { setPreferences } from "../redux/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { extractNumbersFromString, getUserPhotoSrc } from "../utils/utils";
import { mainButtonStyle } from "../static";
import PhoneNumberInput from "./Inputs/PhoneNumberInput";
import { LockOpen } from "@mui/icons-material";
import { UserAPI } from "../apis/userApi";

const SettingsView = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);

  const [receiveEmails, setReceiveEmails] = useState(false);
  const [receiveTexts, setReceiveTexts] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState("");
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    setReceiveEmails(user.preferences.receiveEmails);
    setReceiveTexts(user.preferences.receiveTexts);
    setPhoneNumber(user.preferences.phoneNumber);
  }, [user.preferences]);

  const updatePreferences = async () => {
    const body = {
      receiveEmails,
      receiveTexts,
      phoneNumber: extractNumbersFromString(phoneNumber),
    } as any;

    try {
      const newps = await PreferencesAPI.updatePreferences(body);
      dispatch(setPreferences(newps));
      setShowMsg(true);
      setMsg("Profile saved");
    } catch (e: any) {
      console.log(e.response.data.message);
      alert(e.response.data.message);
    }
  };

  const unblockUser = async (
    workerId: string
  ) => {
    
    try {
      await UserAPI.unblock(workerId);
      // dispatch(setUser(u)); // re-enable without reloading // do a unblock user action in redux slics 
      setMsg("User unblocked");
      setShowMsg(true);
    } catch (e) {
      alert(`Error: ${e}`);
    }
  };

  const tabsContent = (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={(e, v) => setTabValue(v)}
          aria-label="settings tabs"
        >
          <Tab label="Profile" value={0} />
          <Tab label="Blocked Users" value={1} />
        </Tabs>
      </Box>
    </Box>
  );

  const getTabContent = () => {
    switch (tabValue) {
      case 0:
        return profileSettingsContent;
      case 1:
        if (user&& user.blocks && user.blocks.length > 0) {
          return blockedUsersContent;
        } else return noBlockedUsersContent;


      default:
        break;
    }
  };

  const noBlockedUsersContent = (
    <Alert>
      You have not blocked any users
    </Alert>
  )
  const blockedUsersContent = (
    <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
      {
        user.blocks.map((u: any) => {
          return (
            <ListItem
              sx={{ display: "flex", alignItems: "center" }}
              secondaryAction={
                <Tooltip title="Unblock User">
                  <IconButton aria-label="comment" onClick={() => unblockUser(u.id)}>
                    <LockOpen />
                  </IconButton>
                </Tooltip>
              }
            >
              <ListItemAvatar>
                <Avatar alt={u.name} src={getUserPhotoSrc(u.id)} />
              </ListItemAvatar>
              <ListItemText primary={u.name} />
            </ListItem>
          );
        })}

    </List>
  );

  const profileSettingsContent = (
    <Grid2
      container
      sx={{
        margin: "1rem",
        border: "1px none",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid2 size={12}>
        <Typography variant="h3">Settings</Typography>
      </Grid2>
      <Grid2
        size={12}
        sx={{
          marginTop: "3rem",
          border: "1px none green",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <Avatar
          alt="u"
          sx={{ width: "100px", height: "100px" }}
          src={getUserPhotoSrc(user.id)}
        />
      </Grid2>
      <Grid2
        size={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "0.5rem",
        }}
      >
        {user.name}
      </Grid2>

      <Grid2
        size={12}
        sx={{ display: "flex", justifyContent: "center", paddingTop: "3rem" }}
      >
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={receiveEmails}
                onChange={(e) => setReceiveEmails(e.target.checked)}
              />
            }
            label="Receive email notifications"
          />
        </FormGroup>
      </Grid2>

      <Grid2
        size={12}
        sx={{ display: "flex", justifyContent: "center", paddingTop: "3rem" }}
      >
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={receiveTexts}
                onChange={(e) => setReceiveTexts(e.target.checked)}
              />
            }
            label="Receive text notifications"
          />
        </FormGroup>
      </Grid2>

      <Grid2
        size={12}
        sx={{ display: "flex", justifyContent: "center", paddingTop: "3rem" }}
      >
        <FormGroup>
          <FormControlLabel
            control={
              <PhoneNumberInput
                value={phoneNumber}
                onChange={(v) => setPhoneNumber(v)}
              />
            }
            label="send texts here"
          />
        </FormGroup>
      </Grid2>

      <Grid2 size={12} style={{ paddingTop: "3rem" }}>
        <Button
          variant="contained"
          style={mainButtonStyle}
          disabled={
            user.preferences.receiveEmails === receiveEmails &&
            user.preferences.receiveTexts === receiveTexts &&
            user.preferences.phoneNumber ===
              extractNumbersFromString(phoneNumber)
          }
          onClick={updatePreferences}
        >
          Save
        </Button>
      </Grid2>
    </Grid2>
  );

  return (
    <>
      <Snackbar
        open={showMsg}
        autoHideDuration={6000}
        onClose={() => setShowMsg(false)}
        message={msg}
      >
        <Alert
          onClose={() => setShowMsg(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>
      {tabsContent}
      {getTabContent()}
    </>
  );
};

export default SettingsView;
